import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import PriceMain from './PriceMain';
import Footer from '../../components/Footer';

const Price = () => {
  return (
    <>
      <HeaderSeven />

      <PriceMain />

      <Footer />
    </>
  );
};

export default Price;
